var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperatureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "thpfkqvgga",
    width: "374.3%",
    height: "374.3%",
    x: "-137.1%",
    y: "-137.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 3,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 13
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "54ba22kljb",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1264 -198) translate(1190 48) translate(20 127) translate(0 18) translate(54 5)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#thpfkqvgga)",
    xlinkHref: "#54ba22kljb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#54ba22kljb"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H19.886V19.886H0z",
    transform: "translate(-1264 -198) translate(1190 48) translate(20 127) translate(0 18) translate(54 5) translate(7.955 8.75)"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1E2447"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.844.018c-.818 0-1.48.656-1.48 1.464v10.097l.74-.278V1.525c0-.404.331-.768.74-.768s.74.364.74.768V11.3l.74.278V1.482c0-.809-.662-1.464-1.48-1.464z",
    transform: "translate(-1264 -198) translate(1190 48) translate(20 127) translate(0 18) translate(54 5) translate(7.955 8.75) translate(5.966 1.989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.584 10.876v.768c.783.295 1.34 1.044 1.34 1.921 0 1.135-.931 2.056-2.08 2.056s-2.08-.92-2.08-2.056c0-.877.557-1.626 1.34-1.92v-.77c-1.199.322-2.08 1.404-2.08 2.69 0 1.54 1.262 2.787 2.82 2.787 1.558 0 2.82-1.247 2.82-2.787 0-1.286-.881-2.368-2.08-2.69z",
    transform: "translate(-1264 -198) translate(1190 48) translate(20 127) translate(0 18) translate(54 5) translate(7.955 8.75) translate(5.966 1.989)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "M2.92.4c0 .204-.162.369-.364.369H.37C.17.769.006.604.006.4.006.197.169.032.37.032h2.186c.202 0 .365.165.365.368z",
    transform: "translate(-1264 -198) translate(1190 48) translate(20 127) translate(0 18) translate(54 5) translate(7.955 8.75) translate(5.966 1.989) translate(4.998 2.068)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2447",
    d: "M2.92.4c0 .204-.162.369-.364.369H.37C.17.769.006.604.006.4.006.197.169.032.37.032h2.186c.202 0 .365.165.365.368zM2.192 2.226c0 .203-.163.368-.364.368H.37c-.201 0-.364-.165-.364-.368 0-.204.163-.369.364-.369h1.458c.201 0 .364.165.364.369zM2.192 5.877c0 .203-.163.368-.364.368H.37c-.201 0-.364-.165-.364-.368 0-.204.163-.369.364-.369h1.458c.201 0 .364.165.364.369zM2.92 4.051c0 .204-.162.369-.364.369H.37c-.201 0-.364-.165-.364-.369 0-.203.163-.368.364-.368h2.186c.202 0 .365.165.365.368zM2.92 7.702c0 .203-.162.368-.364.368H.37c-.201 0-.364-.165-.364-.368 0-.204.163-.369.364-.369h2.186c.202 0 .365.165.365.369z",
    transform: "translate(-1264 -198) translate(1190 48) translate(20 127) translate(0 18) translate(54 5) translate(7.955 8.75) translate(5.966 1.989) translate(4.998 2.068)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2447",
    d: "M3.205 6.568c0-.2-.159-.363-.354-.363h-.015c-.195 0-.354.162-.354.363v5.451c-.729.17-1.276.84-1.276 1.639 0 .927.735 1.681 1.638 1.681.903 0 1.637-.754 1.637-1.681 0-.8-.547-1.469-1.276-1.639V6.568z",
    transform: "translate(-1264 -198) translate(1190 48) translate(20 127) translate(0 18) translate(54 5) translate(7.955 8.75) translate(5.966 1.989)"
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureIcon);
export default __webpack_public_path__ + "static/media/temperature-icon.ac9734f6.svg";
export { ForwardRef as ReactComponent };